import { postAsUriParameters } from '@namespace/helpers';

export const getCashdesks = ({ walletHash, language, cityId, amount }) =>
  postAsUriParameters('/accounting/api/get_cash_desk', {
    wallet_hash: walletHash,
    lang: language,
    city_id: cityId,
    amount
  }).then(({ response }) => response);
